import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, retry } from 'rxjs/operators';
import { Toastr } from './toastrService';
import { Router } from '@angular/router';
// import { EncryptionService } from './encryption.service';
// import { ToastrServices } from './toastrService';
@Injectable({
  providedIn: 'root',
})
export class httpClientService {

  private httpHeaders = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET',
      'Access-Control-Allow-Origin': '*',
     "Accept":"application/json, text/plain",
     "user-type":"ADMIN",
     'Authorization':'Bearer ' + localStorage.getItem('token-admin')

    //  "Authentication":""
     //change to "user-type":"CUSTOMER" 
     
    })
  };

  options: {
    headers?: HttpHeaders | { [header: string]: string | string[] };
    observe?: 'body' | 'events' | 'response';
    params?:
      | HttpParams
      | {
          [param: string]:
            | string
            | number
            | boolean
            | ReadonlyArray<string | number | boolean>;
        };
    reportProgress?: boolean;
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
    withCredentials?: boolean;
  };
  constructor(private http: HttpClient, private toast:Toastr, 
    private router: Router

    ) {}

  public get(url: any,params?:any): Observable<any> {
    console.log(url,"urlHere");
    
      return this.http.get(url  ,{headers:this.httpHeaders.headers,params}).pipe(
      
      tap({
 
    error: (error) => {
      if (error.error && error.error.status === 404) {
        let errorMessage = error.error.error;
        this.toast.showInfo(errorMessage)
      }

         else if (error.error && error.error.status === 500) {
        let errorMessage = error.error.body.error;
        this.toast.showError(errorMessage)
       } 
       else if (error.error && error.error.body.error) {
        let errorMessage = error.error.body.error;
        this.toast.showError(errorMessage)
       } 
       else if (error.error && error.error.status === 400) {
        let errorMessage = error.error.body.detail;
        this.toast.showInfo(errorMessage)
      }
      else if (error.error && error.error.body.detail) {
        let errorMessage = error.error.body.detail;
        this.toast.showInfo(errorMessage)
      }
      else if (error.error.body.message.plainText ) {
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage);
        // this.router.navigate(['/auth-admin/login'])
        // this.router.navigate(['/dashboard'])

       }
      else if (error.error && error.error.body.httpStatusCode === 403) {
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage)
       } 
       else if (error.error.body.httpStatusCode === 401 ) {
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage);
        // this.router.navigate(['/auth-admin/login'])
        // this.router.navigate(['/dashboard'])

       } 
   
       else if (error.error && error.error.body.message.plainText && error.error.body.status === 404 ){
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage);
        // this.router.navigate(['/dashboard'])
       }
       else if (error.error && error.error.body.message ) {
        let errorMessage = error.error.body.message;
        this.toast.showError(errorMessage)
       }
      else {
        this.toast.showError("An unexpected error occurred. Please try again later.");
        // this.router.navigate(['/auth-admin/login'])

      }
    }
})
);
   
  }

  public delete(url: any,params:any): Observable<any> {
    
      return this.http.delete(url  ,{headers:this.httpHeaders.headers,params:params}).pipe(
      
      tap({
  
      error: (error) => {
        if (error.error && error.error.status === 404) {
          let errorMessage = error.error.error;
          this.toast.showInfo(errorMessage)
        }
    
           else if (error.error && error.error.status === 500) {
          let errorMessage = error.error.body.error;
          this.toast.showError(errorMessage)
         } 
         else if (error.error && error.error.body.error) {
          let errorMessage = error.error.body.error;
          this.toast.showError(errorMessage)
         } 
         else if (error.error.body.message.plainText ) {
          let errorMessage = error.error.body.message.plainText;
          this.toast.showError(errorMessage);
          // this.router.navigate(['/auth-admin/login'])
          // this.router.navigate(['/dashboard'])
  
         }
         else if (error.error && error.error.status === 400) {
          let errorMessage = error.error.body.detail;
          this.toast.showInfo(errorMessage)
        }
        else if (error.error && error.error.body.detail) {
          let errorMessage = error.error.body.detail;
          this.toast.showInfo(errorMessage)
        }
        else if (error.error && error.error.body.httpStatusCode === 403) {
          let errorMessage = error.error.body.message.plainText;
          this.toast.showError(errorMessage)
         } 
         else if ((error.error && error.error.body.message.plainText) || error.error.body.httpStatusCode === 401 ) {
          let errorMessage = error.error.body.message.plainText;
          this.toast.showError(errorMessage);
          // this.router.navigate(['/auth-admin/login'])
         } 
         else if (error.error && error.error.body.message ) {
          let errorMessage = error.error.body.message;
          this.toast.showError(errorMessage)
         }
        else {
          this.toast.showError("An unexpected error occurred. Please try again later.");
          // this.router.navigate(['/auth-admin/login'])
  
        }
      }
  })
  );
  }
  public post(url: any, body: any): Observable<any> {
    return this.http.post(url, body,  {headers:this.httpHeaders.headers}).pipe(
      tap({
      
        error: (error) => {
          if (error.error && error.error.status === 404) {
            let errorMessage = error.error.error;
            this.toast.showInfo(errorMessage)
          }
        
             else if (error.error && error.error.status === 500) {
            let errorMessage = error.error.body.error;
            this.toast.showError(errorMessage)
           } 
           else if (error.error && error.error.body.error) {
            let errorMessage = error.error.body.error;
            this.toast.showError(errorMessage)
           } 
           else if (error.error.body.message.plainText ) {
            let errorMessage = error.error.body.message.plainText;
            this.toast.showError(errorMessage);
            // this.router.navigate(['/auth-admin/login'])
            // this.router.navigate(['/dashboard'])
    
           }
           else if (error.error && error.error.status === 400) {
            let errorMessage = error.error.body.detail;
            this.toast.showInfo(errorMessage)
          }
          else if (error.error && error.error.body.detail) {
            let errorMessage = error.error.body.detail;
            this.toast.showInfo(errorMessage)
          }
          else if (error.error && error.error.body.httpStatusCode === 403) {
            let errorMessage = error.error.body.message.plainText;
            this.toast.showError(errorMessage)
           } 
           else if ((error.error && error.error.body.message.plainText) || error.error.body.httpStatusCode === 401 ) {
            let errorMessage = error.error.body.message.plainText;
            this.toast.showError(errorMessage);
            // this.router.navigate(['/auth-admin/login'])
           } 
           else if (error.error && error.error.body.message ) {
            let errorMessage = error.error.body.message;
            this.toast.showError(errorMessage)
           }
          else {
            this.toast.showError("An unexpected error occurred. Please try again later.");
            // this.router.navigate(['/auth-admin/login'])
    
          }
        }
    })
    );
  }


  public put(url: any,body:any): Observable<any> {
      return this.http.put(url,body).pipe(
      tap({
    error: (error) => {
      if (error.error && error.error.status === 404) {
        let errorMessage = error.error.error;
        this.toast.showInfo(errorMessage)
      }
         else if (error.error && error.error.status === 500) {
        let errorMessage = error.error.body.error;
        this.toast.showError(errorMessage)
       } 
       else if (error.error && error.error.body.error) {
        let errorMessage = error.error.body.error;
        this.toast.showError(errorMessage)
       } 
       else if (error.error.body.message.plainText ) {
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage);
        // this.router.navigate(['/auth-admin/login'])
        // this.router.navigate(['/dashboard'])

       }
       else if (error.error && error.error.status === 400) {
        let errorMessage = error.error.body.detail;
        this.toast.showInfo(errorMessage)
      }
      else if (error.error && error.error.body.detail) {
        let errorMessage = error.error.body.detail;
        this.toast.showInfo(errorMessage)
      }
      else if (error.error && error.error.body.httpStatusCode === 403) {
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage)
       } 
       else if ((error.error && error.error.body.message.plainText) || error.error.body.httpStatusCode === 401 ) {
        let errorMessage = error.error.body.message.plainText;
        this.toast.showError(errorMessage);
        // this.router.navigate(['/auth-admin/login'])
       } 
       else if (error.error && error.error.body.message ) {
        let errorMessage = error.error.body.message;
        this.toast.showError(errorMessage)
       }
      else {
        this.toast.showError("An unexpected error occurred. Please try again later.");
        // this.router.navigate(['/auth-admin/login'])

      }
    }
})
);
  }
}
